import React from "react";
import PropTypes from "prop-types";
import { Grid, TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";

function maybeGrid(asGrid, node) {
  if (!asGrid) {
    return node;
  }
  return (
    <Grid item xs={12}>
      {node}
    </Grid>
  );
}

export default function OccurrenceNotesFields({
  notesName,
  notesValue,
  internalNotesValue,
  onChange,
  disabled,
  showInternal,
  hideNotes,
  requireNotes,
  margin,
  asGrid
}) {
  const { t } = useTranslation();
  return (
    <>
      {!hideNotes &&
        maybeGrid(
          asGrid,
          <TextField
            disabled={disabled}
            onChange={onChange}
            name={notesName}
            id={notesName}
            label={t("common.labels.notes")}
            value={notesValue}
            fullWidth
            rowsMax="7"
            multiline
            margin={margin}
            required={requireNotes}
          />
        )}
      {showInternal &&
        maybeGrid(
          asGrid,
          <TextField
            disabled={disabled}
            onChange={onChange}
            name="internalNotes"
            id="internalNotes"
            label={t("occurrences.advanced.internalNotes")}
            value={internalNotesValue}
            fullWidth
            rowsMax="7"
            multiline
            margin={margin}
          />
        )}
    </>
  );
}

OccurrenceNotesFields.propTypes = {
  notesName: PropTypes.string,
  notesValue: PropTypes.string,
  internalNotesValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  showInternal: PropTypes.bool,
  hideNotes: PropTypes.bool,
  requireNotes: PropTypes.bool,
  margin: PropTypes.string,
  asGrid: PropTypes.bool
};

OccurrenceNotesFields.defaultProps = {
  notesName: "notes",
  notesValue: "",
  internalNotesValue: "",
  disabled: false,
  showInternal: false,
  hideNotes: false,
  requireNotes: false,
  margin: undefined,
  asGrid: false
};
